export enum LoginScreen {
  EMAIL = "EMAIL",
  PASS_CODE = "PASS_CODE",
  SELECT_SUBSCRIPTION = "SELECT_SUBSCRIPTION"
}